import React, { Suspense, lazy } from 'react';
import '../../App.css';
import Seo from '../Seo';
import HeroSection from '../HeroSection';
import FreeAdmissionBand from '../FreeAdmissionBand';
import TrustPromise from '../TrustPromise';
import HomePartnersWall from '../HomePartnersWall';
import HomeStats from '../HomeStats';
import HomeAnnouncements from '../HomeAnnouncements';
import HowItWorks from '../HowItWorks';
import StudyDestinations from '../StudyDestinations';
import FeaturedUniversities from '../FeaturedUniversities';
import Footer from '../Footer';
import LoadingSpinner from '../LoadingSpinner';
import { faqs } from '../Services';

// Sections 8-13 (results table through the closing CTA band) are below the
// fold on every viewport this site supports, so none of them belong in the
// homepage's initial JS payload — each is its own lazy chunk, loaded once
// the browser is idle rather than blocking first paint.
const ResultsTable = lazy(() => import('../ResultsTable'));
const SuccessStories = lazy(() => import('../SuccessStories'));
const Counsellors = lazy(() => import('../Counsellors'));
const InsightsTeaser = lazy(() => import('../InsightsTeaser'));
const HomeFAQ = lazy(() => import('../HomeFAQ'));
const ClosingCta = lazy(() => import('../ClosingCta'));

// The FAQPage JSON-LD for HomeFAQ's content is built here, at the top level,
// instead of inside that lazy-loaded component — this way it's present in
// the very first render rather than deferred behind a chunk load. Reuses
// the exact same 6 questions HomeFAQ renders and ServicesPage.js already
// marks up for /services, so the two never drift apart.
const homeFaqJsonLd = {
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: { '@type': 'Answer', text: f.answer },
  })),
};

function Home() {
  return (
    <>
      <Seo
        title="Study in Turkey — University Admissions & Scholarships"
        description="VisionExploit helps students get into top Turkish universities — free consultations, visa support, and scholarship guidance from application to arrival."
        jsonLd={homeFaqJsonLd}
      />
      <HeroSection />
      <FreeAdmissionBand />
      <TrustPromise />
      <HomePartnersWall />
      <HomeStats />
      <HomeAnnouncements />
      <HowItWorks />
      <StudyDestinations />
      <FeaturedUniversities />

      <Suspense fallback={<LoadingSpinner minHeight={300} label="Loading..." />}>
        <ResultsTable />
      </Suspense>
      <Suspense fallback={<LoadingSpinner minHeight={500} label="Loading..." />}>
        <SuccessStories />
      </Suspense>
      <Suspense fallback={<LoadingSpinner minHeight={400} label="Loading..." />}>
        <Counsellors />
      </Suspense>
      <Suspense fallback={<LoadingSpinner minHeight={400} label="Loading..." />}>
        <InsightsTeaser />
      </Suspense>
      <Suspense fallback={<LoadingSpinner minHeight={300} label="Loading..." />}>
        <HomeFAQ />
      </Suspense>
      <Suspense fallback={<LoadingSpinner minHeight={260} label="Loading..." />}>
        <ClosingCta />
      </Suspense>

      <Footer />
    </>
  );
}

export default Home;
